import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QuickOrderComponent } from '@spartacus/cart/quick-order/components';

@Component({
    selector: 'gen-quick-order',
    templateUrl: './quick-order.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenQuickOrderComponent extends QuickOrderComponent {}
